module.exports = "<i class=material-icons ng-click=vm.exportData() title=\"Save as '{{vm.name}}'\">&#xE2C4;</i>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/common/exportbutton/template.html
// module id = 35
// module chunks = 0